var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import omit from 'lodash/omit';
import React, { forwardRef } from 'react';
import { TableCell as EdsTableCell } from '@ellucian/react-design-system/core/es/Table';
import Tokens from '../styles/Tokens';
import { createStyles, withStyles } from '../styles/withStyles';
const styles = createStyles({
    body: {},
    head: {},
    loader: {
        animation: 'blinker 4s linear infinite',
        backgroundColor: Tokens.colorBrandNeutral300,
        borderRadius: Tokens.borderRadiusSmall,
        display: 'block',
        height: Tokens.spacing40,
        width: Tokens.widthFluid
    },
    root: {}
});
const TableCell = (props, ref) => {
    const { children, classes, loading } = props, rest = __rest(props, ["children", "classes", "loading"]);
    return (React.createElement(EdsTableCell, Object.assign({ classes: Object.assign({}, omit(classes, ['loader'])), ref: ref }, rest), loading ? (React.createElement("span", { className: classes.loader })) : (React.createElement(React.Fragment, null, children))));
};
const TableCellFRC = forwardRef(TableCell);
TableCellFRC.displayName = 'TableCellFRC';
export default withStyles(styles, { name: 'TableCellWS' })(TableCellFRC);
